export function fromJSON(json) {
  return JSON.parse(json);
}

export function toJSON(obj) {
  return JSON.stringify(obj);
}

export function isEqual(first, second){
  return toJSON(first) === toJSON(second);
}